import React, { Fragment } from 'react';
import HTMLReactParserSafe from '../../partials/html-react-parser-safe';
import {AlgoliaHitInterface} from "../admin-dashboard-tables/interfaces";

interface Props {
  hit: AlgoliaHitInterface,
  displayKey: string[],
}

const SuggestedHit: React.FC<Props> = ({
                                         hit,
                                         displayKey,
                                       }) => {
  const renderDisplayKey = (item, key, displaySeparator, separator) => {
    // If is array, perform recursion
    if (Array.isArray(key)) {
      return key.map((subKey, i) => (
        renderDisplayKey(item, subKey, i !== key.length - 1, ', ')
      ));
    }

    /* eslint-disable-next-line no-underscore-dangle */
    const html = item._highlightResult[key].value
      .replaceAll('__aa-highlight__', '<em>')
      .replaceAll('__/aa-highlight__', '</em>');

    return (
      // Algolia warns here: https://www.algolia.com/doc/guides/building-search-ui/ui-and-ux-patterns/highlighting-snippeting/js/#sanitization-of-the-results
      // that results must be sanitized, which this component performs
      <Fragment key={item[key]}>
        <HTMLReactParserSafe
          html={html}
        />
        {displaySeparator && separator}
      </Fragment>
    );
  };
  return (
    <span key={hit.objectID}>
      {displayKey.map((key, i) => (
        renderDisplayKey(hit, key, i !== displayKey.length - 1, <span className="separator" />)
      ))}
    </span>
  );
};

export default SuggestedHit;
